var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 15,
    viewBox: "0 0 3 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22391 10.52C2.03724 10.7067 1.80391 10.8 1.52391 10.8C1.24391 10.8 1.00391 10.7067 0.803906 10.52C0.61724 10.32 0.51724 10.08 0.503906 9.8L0.263906 1.54C0.250573 1.23333 0.350573 0.966666 0.563906 0.739999C0.790573 0.513333 1.05724 0.4 1.36391 0.4H1.68391C1.99057 0.4 2.25057 0.513333 2.46391 0.739999C2.69057 0.966666 2.79724 1.23333 2.78391 1.54L2.54391 9.8C2.53057 10.08 2.42391 10.32 2.22391 10.52ZM1.58391 12.4C1.89057 12.4 2.15724 12.5133 2.38391 12.74C2.61057 12.9667 2.72391 13.2333 2.72391 13.54V13.86C2.72391 14.1667 2.61057 14.4333 2.38391 14.66C2.15724 14.8867 1.89057 15 1.58391 15H1.46391C1.15724 15 0.890573 14.8867 0.663906 14.66C0.43724 14.4333 0.323906 14.1667 0.323906 13.86V13.54C0.323906 13.2333 0.43724 12.9667 0.663906 12.74C0.890573 12.5133 1.15724 12.4 1.46391 12.4H1.58391Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityButton);
export default __webpack_public_path__ + "static/media/priority-button.bd2fd873ba8bbb4af50143c068dc9e0b.svg";
export { ForwardRef as ReactComponent };